// extracted by mini-css-extract-plugin
export default {"custom-element-preview-container":"CQGagc","customElementPreviewContainer":"CQGagc","premium-banner":"gTBxS1","premiumBanner":"gTBxS1"};